import { z } from "zod"
const RFC_REGEX =
  /^([A-Z&Ñ]{3,4})\d{6}[A-Z0-9]{3}$/;
export const dependenciaSchema = z.object({
  rfc: z
    .string()
    .trim()
    .min(1, "El RFC es obligatorio")
    .toUpperCase()
    .regex(RFC_REGEX, "El RFC no tiene un formato válido")
    .refine(
      (value) => value.length === 12 || value.length === 13,
      {
        message: "El RFC debe tener 12 o 13 caracteres",
      }
    ),
  name: z.string({
    required_error: "El nombre de la dependencia es obligatorio",
    invalid_type_error: "El nombre debe ser un texto",
  }).min(1, "El nombre de la dependencia es obligatorio")
    .max(255, 'El nombre de la dependencia no puede tener mas de 200 caracteres'),
  organism: z.string().max(255, 'El organismo no puede tener mas de 200 caracteres').optional(),
  status: z.boolean({
  required_error: "El estatus es obligatorio",
  invalid_type_error: "El estatus debe ser verdadero o falso",
})
  // status: z.string({
  //   required_error: "El estatus es obligatorio",
  //   invalid_type_error: "El estatus debe ser un texto",
  // }).min(1, "Elige un estatus porfavor"),
})